import React from 'react';
import Colors from '@data/enums/Color.enum';

export function eggs({ fill = Colors.TEXT_DEFAULT }) {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10.0445 14.7368C11.8384 14.7368 13.2926 13.2826 13.2926 11.4887C13.2926 9.69483 11.8384 8.2406 10.0445 8.2406C8.25062 8.2406 6.79639 9.69483 6.79639 11.4887C6.79639 13.2826 8.25062 14.7368 10.0445 14.7368Z'
        fill={fill} />
      <path fillRule='evenodd'
        clipRule='evenodd'
        d='M14.5558 11.4888C14.5558 13.9803 12.536 16.0001 10.0445 16.0001C7.55297 16.0001 5.5332 13.9803 5.5332 11.4888C5.5332 8.99726 7.55297 4.04517 10.0445 4.04517C12.536 4.04517 14.5558 8.99726 14.5558 11.4888ZM13.9558 11.4888C13.9558 13.6489 12.2046 15.4001 10.0445 15.4001C7.88434 15.4001 6.1332 13.6489 6.1332 11.4888C6.1332 10.3643 6.60185 8.59939 7.38535 7.11234C7.77433 6.37407 8.2231 5.73913 8.69764 5.29672C9.17449 4.85214 9.62855 4.64517 10.0445 4.64517C10.4604 4.64517 10.9145 4.85214 11.3913 5.29672C11.8659 5.73913 12.3146 6.37407 12.7036 7.11234C13.4871 8.59939 13.9558 10.3643 13.9558 11.4888Z'
        fill={fill} />
    </svg>
  );
}
